import { orderStatusService } from '@afterpaytouch/order-status-api/order'

export const {
  useGetStatusQuery,
  useLazyGetStatusQuery,
  endpoints: { getStatus },
} = orderStatusService
